import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import "./index.css";
import { getApiBaseUrl } from "@config/shared/api-paths";
import { migrateLegacyStorageKeys } from "@utils/shared/storage/migrate-legacy-storage-keys";

// Initialize FontAwesome icons
import "./fontawesome";

// Initialize i18n
import "./locales/i18n";

// The API always lives on a different host from this app (api.oxygen... vs. wherever
// this SPA is served), so a Toolbox app running in its own blob: iframe (SingleApp.jsx)
// can never assume its parent's origin is the API's. Stashed here the same way
// accessToken is (see tokenService.jsx) - readable by a same-origin iframe via sessionStorage.
sessionStorage.setItem("apiBaseUrl", getApiBaseUrl());

// Rename pre-normalisation localStorage keys before anything reads them —
// ExpandableSideBar reads its persisted width synchronously on first render.
migrateLegacyStorageKeys();

// adding this to use useBlocker for navigation blocking in form dirty cases
const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router}  />
  </React.StrictMode>
);
